import React, { useState } from 'react';
import { saveNewTask } from "../../store/grupo.actions";
import { saveNewSubTask } from "../../store/grupo.actions"
import {archivarElementos,updateAfterDelete } from "../../store/grupo.actions";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { FiTrash } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { BsArrowRightCircle, BsFillCircleFill } from 'react-icons/bs';
import { SelectModal } from './modal-option-grouptask'; // Importa el nuevo componente
import { ROLES } from '../../cmps/../services/user.service';
import { userService } from '../../cmps/../services/user.service';
import { BsArrow90DegUp } from "react-icons/bs";

export function TaskToolsModal({ tasks, group, board, setSelectedTasks, setIsMainCheckbox, modalElection}) {
    let _ = require('lodash');

    const [isMoveMenuVisible, setIsMoveMenuVisible] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [taskIds, setTaskIds] = useState([]); // Estado para almacenar identificadores de tareas
    const user = userService.getLoggedinUser().data.data; // Usuario logueado en la interfaz
    const isEditable = user.rol === ROLES.ADMIN;

    async function onRemoveTasks() {
        try {
            let id_actividades = [];
            let id_subactividades = [];
    
            const promises = tasks.map(async (task) => {
                if (task.id_subactividad === undefined) {
                    id_actividades.push(task.id_actividad);
                } else {
                    id_subactividades.push(task.id_subactividad);
                }
            });
            
            await Promise.all(promises);
    
            if (id_actividades.length > 0) {
              
                await archivarElementos(id_actividades, "actividades");
                updateAfterDelete(id_actividades, "actividades");

            }else if(id_subactividades.length > 0) {
                
                await archivarElementos(id_subactividades, "subactividades");
                updateAfterDelete(id_subactividades, "subactividades");

            }
    
            // Limpiar las tareas seleccionadas y el checkbox principal
            setSelectedTasks([]);
            setIsMainCheckbox({ isActive: false });
    
        } catch (err) {
            console.error(err);
        }
    }
    


    async function onDuplicateTasks() {
        try {
            // Itera sobre todas las tareas seleccionadas
            await Promise.all(tasks.map(async (task) => {
                let newTask;
                
                if (task.id_actividad) {
                    // Es una actividad
                    newTask = _.cloneDeep(task);
    
                    // Elimina propiedades que no deben ser duplicadas
                    delete newTask.id_actividad;
                    delete newTask.subactividades;
                    delete newTask.archivosactividad;
    
                    newTask.descripcion = newTask.descripcion + " (Copy)";
    
                    // Guarda la nueva tarea (actividad)
                    const savedTask = await saveNewTask(newTask, newTask.fk_grupo_id);
    
                    // Duplica las subactividades asociadas, si existen
                    if (task.subactividades) {
                        await Promise.all(task.subactividades.map(async (subactividad) => {
                            const newSubTask = _.cloneDeep(subactividad);
    
                            // Elimina propiedades que no deben ser duplicadas
                            delete newSubTask.id_subactividad;
                            delete newSubTask.archivossubactividad;
    
                            // Actualiza la referencia de actividad en la subactividad duplicada
                            newSubTask.fk_actividad_id = savedTask.id_actividad;
    
                            // Guarda la nueva subactividad
                            await saveNewSubTask(newSubTask, newTask.fk_grupo_id, savedTask.id_actividad);
                        }));
                    }
                } else if (task.id_subactividad) {
                    // Es una subactividad
                    newTask = _.cloneDeep(task);
    
                    // Elimina propiedades que no deben ser duplicadas
                    delete newTask.group_id;
                    delete newTask.id_subactividad;
                    delete newTask.archivossubactividad;
                    delete newTask.responsable;

                    newTask.descripcion = newTask.descripcion + " (Copy)";
    
                    // Guarda la nueva subactividad (esta operación asume que se necesita una función similar a `saveNewTask` para subactividades)
                    await saveNewSubTask(newTask, task.group_id, task.fk_actividad_id);
                }
            }));
    
            // Opcionalmente, puedes restablecer los estados después de duplicar
            setIsMainCheckbox({ isActive: false });
            setSelectedTasks([]);
    
        } catch (err) {
            console.error(err);
        }
    }

    

    function onClose() {
        setSelectedTasks([]);
        setIsMainCheckbox({ isActive: false });
    }

    function toggleMoveMenu() {
        setIsMoveMenuVisible(!isMoveMenuVisible);
    }

    function openModal() {
        if (isEditable) {  // Verifica que sea editable antes de abrir el modal
            setTaskIds(tasks.map(task => task.id_actividad || task.id_subactividad)); // Extrae los identificadores una sola vez
          
            setIsModalOpen(true);  // Solo abre el modal una vez
        }
    }

    function closeModal() {
        setIsModalOpen(false);
    }

    function handleSelect(item) {
        onClose();
      
    }

    return (
        <section className="task-tools-modal flex">
            <div className="task-tools flex">
                <div className="task-count">
                    {tasks.length}
                </div>
                <div className="tasks-container flex">
                    <div className="task-info flex">
                        <span>Elemento{tasks.length > 1 ? "s" : ""} Seleccionado{tasks.length > 1 ? "s" : ""}</span>
                        <div className="group-color flex">
                            {_.times(tasks.length, () => <BsFillCircleFill key={_.uniqueId('KEY_')} className="icon" style={{ color: group.color }} />)}
                        </div>
                    </div>
                    <div className="task-btns flex">
                        <div onClick={onDuplicateTasks}>
                            <HiOutlineDocumentDuplicate className="icon" />
                            Duplicar
                        </div>

                        {modalElection !== "SubGroupPreview" && (
                            <div 
                                onClick={() => isEditable && openModal()}  
                                className={`move-btn ${!isEditable ? 'disabled' : ''}`}
                                style={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
                            >
                                <BsArrowRightCircle className="icon" />
                                Mover
                            </div>
                        )}

                        {modalElection !== "GroupPreview" && (
                                <div 
                                    onClick={() => isEditable && openModal()}  
                                    className={`move-btn ${!isEditable ? 'disabled' : ''}`}
                                    style={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
                                >
                                    <BsArrow90DegUp className="icon" />
                                    Convertir
                                </div>
                            )}


                        <div onClick={onRemoveTasks}>
                            <FiTrash className="icon"/>
                            Eliminar
                        </div>
                    </div>
                    <div className="close-btn" onClick={onClose}>
                        <IoCloseOutline className="icon" />
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <SelectModal open={isModalOpen} onClose={closeModal} onSelect={handleSelect} taskIds={taskIds} actionM = {modalElection} />
            )}
            <style >{`
                .move-btn {
                    position: relative;
                }
            `}</style>
        </section>
    );
}
